import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { useDocumentTitle } from '../utils/useDocumentTitle';
export function PrivacyPage() {
  useDocumentTitle('Política de Privacidad | Cricket');
  return <div className="min-h-screen bg-white" data-id="element-5229">
      <div className="max-w-3xl mx-auto px-6 py-12" data-id="element-5230">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-gray-400 hover:text-gray-900 transition-colors mb-10" data-id="element-5231">
          <ArrowLeft className="w-4 h-4" data-id="element-5232" />
          Volver al inicio
        </Link>

        <div className="flex items-center gap-3 mb-8" data-id="element-5233">
          <div className="p-2.5 bg-gray-100 rounded-xl" data-id="element-5234">
            <Shield className="w-6 h-6 text-gray-700" data-id="element-5235" />
          </div>
          <div data-id="element-5236">
            <h1 className="text-3xl font-bold text-gray-900 tracking-tight" data-id="element-5237">
              Política de Privacidad
            </h1>
            <p className="text-sm text-gray-400 mt-1" data-id="element-5238">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-DO', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>
          </div>
        </div>

        <div className="text-gray-700 leading-relaxed text-base space-y-6" data-id="element-5239">
          <section data-id="element-5240">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5241">
              1. Información que Recopilamos
            </h2>
            <p data-id="element-5242">
              Cricket recopila información personal necesaria para la gestión de
              pedidos de alimentos corporativos, incluyendo: nombre completo,
              correo electrónico, empresa y sucursal asignada, historial de
              pedidos y preferencias alimentarias.
            </p>
          </section>

          <section data-id="element-5243">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5244">
              2. Uso de la Información
            </h2>
            <p data-id="element-5245">La información recopilada se utiliza exclusivamente para:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-5246">
              <li data-id="element-5247">Procesar y gestionar pedidos de alimentos</li>
              <li data-id="element-5248">Aplicar subsidios corporativos correspondientes</li>
              <li data-id="element-5249">
                Generar reportes de consumo para las empresas contratantes
              </li>
              <li data-id="element-5250">Mejorar la calidad del servicio</li>
              <li data-id="element-5251">Comunicaciones relacionadas con el servicio</li>
            </ul>
          </section>

          <section data-id="element-5252">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5253">
              3. Protección de Datos
            </h2>
            <p data-id="element-5254">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              alteración, divulgación o destrucción. Los datos se almacenan en
              servidores seguros con encriptación.
            </p>
          </section>

          <section data-id="element-5255">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5256">
              4. Compartir Información
            </h2>
            <p data-id="element-5257">
              No vendemos ni compartimos tu información personal con terceros,
              excepto:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-5258">
              <li data-id="element-5259">
                Con tu empresa contratante (reportes de consumo y subsidios)
              </li>
              <li data-id="element-5260">Cuando sea requerido por ley o autoridad competente</li>
              <li data-id="element-5261">
                Con proveedores de servicios que nos ayudan a operar la
                plataforma
              </li>
            </ul>
          </section>

          <section data-id="element-5262">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5263">
              5. Tus Derechos
            </h2>
            <p data-id="element-5264">
              Conforme a la legislación de República Dominicana, tienes derecho
              a:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-5265">
              <li data-id="element-5266">Acceder a tus datos personales</li>
              <li data-id="element-5267">Solicitar la corrección de datos inexactos</li>
              <li data-id="element-5268">Solicitar la eliminación de tus datos</li>
              <li data-id="element-5269">Oponerte al procesamiento de tus datos</li>
            </ul>
          </section>

          <section data-id="element-5270">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5271">
              6. Cookies y Almacenamiento Local
            </h2>
            <p data-id="element-5272">
              Utilizamos almacenamiento local del navegador para mantener tu
              sesión activa y recordar tus preferencias. No utilizamos cookies
              de seguimiento de terceros.
            </p>
          </section>

          <section data-id="element-5273">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5274">
              7. Contacto
            </h2>
            <p data-id="element-5275">
              Para consultas sobre privacidad o ejercer tus derechos, contacta
              a:{' '}
              <a href="mailto:soporte@cricket.do" className="text-gray-900 font-semibold hover:underline underline-offset-2" data-id="element-5276">
                soporte@cricket.do
              </a>
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-100" data-id="element-5277">
          <div className="flex items-center gap-2" data-id="element-5278">
            <img src="https://i.imgur.com/bxPZvDb.png" alt="Cricket Logo" className="h-7 w-auto object-contain" data-id="element-5279" />
          </div>
          <p className="text-xs text-gray-400 mt-3" data-id="element-5280">
            © {new Date().getFullYear()} Cricket. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </div>;
}